'use client';

import { c as _c } from "react/compiler-runtime";
import { useLocale, useTranslations } from 'next-intl';
import type React from 'react';
import type { ReactNode } from 'react';
import { useUserStore } from '@/entities/User/store/userStoreProvider';
import { usePathname } from '@/i18n/navigation';
import { FastNavLink } from '@/shared/components/FastNavLink';
import { Link } from '../../../i18n/navigation';
import { LanguageSelector } from '../../molecules/LanguageSelector';
import { AccountFilledIcon } from './icon-components/AccountFilledIcon';
import { AccountIcon } from './icon-components/AccountIcon';
import { ActionsFilledIcon } from './icon-components/ActionsFilledIcon';
import { ActionsIcon } from './icon-components/ActionsIcon';
import { LeadersFilledIcon } from './icon-components/LeadersFilledIcon';
import { LeadersIcon } from './icon-components/LeadersIcon';
import { MarketFilledIcon } from './icon-components/MarketFilledIcon';
import { MarketIcon } from './icon-components/MarketIcon';
import { WalletFilledIcon } from './icon-components/WalletFilledIcon';
import { WalletIcon } from './icon-components/WalletIcon';
// Соц сети скрыты - т.к. их пока нет
// import InstagramIcon from './icons/instagram.svg';
// import FacebookIcon from './icons/facebook.svg';
// import TelegramIcon from './icons/telegram.svg';
// import DiscordIcon from './icons/discord.svg';
// import TwitterIcon from './icons/twitter.svg';
// import MediumIcon from './icons/medium.svg';
// import YoutubeIcon from './icons/youtube.svg';
import GlobeIcon from './icons/globe.svg';
// Прямой импорт SVG как React компонентов
import LogoIcon from './icons/logo.svg';
interface FooterV2Props {
  className?: string;
}

// Соц сети скрыты - т.к. их пока нет
// interface SocialLink {
//   href: string;
//   icon: React.ComponentType<React.SVGProps<SVGSVGElement>>;
//   alt: string;
// }

// interface NavSection {
//   title: string;
//   links: Array<{
//     label: string;
//     href: string;
//   }>;
// }

interface MobileNavItem {
  label: string;
  href: string;
  icon: ReactNode;
  activeIcon: ReactNode;
  onClick?: (form: 'login' | 'signup' | 'forgot' | 'password' | null) => void;
}
export const FooterV2: React.FC<FooterV2Props> = t0 => {
  const $ = _c(42);
  const {
    className: t1
  } = t0;
  const className = t1 === undefined ? "" : t1;
  const t = useTranslations("Footer") as any;
  const user = useUserStore(_temp);
  const pathname = usePathname();
  const locale = useLocale();
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  if ($[0] !== className || $[1] !== locale || $[2] !== pathname || $[3] !== t || $[4] !== user?.id) {
    const year = new Date().getFullYear();
    const mobileNavItems = [{
      label: t("MobileNav.Market"),
      href: "/auctions",
      icon: <MarketIcon />,
      activeIcon: <MarketFilledIcon />
    }, {
      label: t("MobileNav.Leaders"),
      href: "/leaderboard",
      icon: <LeadersIcon />,
      activeIcon: <LeadersFilledIcon />
    }, {
      label: t("MobileNav.Actions"),
      href: "/earn",
      icon: <ActionsIcon />,
      activeIcon: <ActionsFilledIcon />
    }, {
      label: t("MobileNav.Wallet"),
      href: user?.id ? "/settings/my-wallet" : "/auth",
      icon: <WalletIcon />,
      activeIcon: <WalletFilledIcon />
    }, {
      label: user?.id ? t("MobileNav.Account") : t("MobileNav.Login"),
      href: user?.id ? "/settings/my-account" : "/auth",
      icon: user?.id ? <AccountIcon /> : <AccountIcon />,
      activeIcon: <AccountFilledIcon />
    }];
    t6 = `bg-[#000000] text-white ${className}`;
    let t8;
    if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
      t8 = <div className="flex flex-col items-center gap-8 py-6"><div className="flex items-center justify-center"><Link href="/"><LogoIcon className="h-[86px] w-[74px]" /></Link></div></div>;
      $[11] = t8;
    } else {
      t8 = $[11];
    }
    let t9;
    if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
      t9 = <div className="border-b border-white/10 py-4"><div className="flex items-center justify-center gap-3"><GlobeIcon className=" opacity-60" /><LanguageSelector /></div></div>;
      $[12] = t9;
    } else {
      t9 = $[12];
    }
    let t10;
    if ($[13] !== t) {
      t10 = t("AllRightsReserved");
      $[13] = t;
      $[14] = t10;
    } else {
      t10 = $[14];
    }
    let t11;
    if ($[15] !== t10) {
      t11 = <p className="mt-1 text-xs text-white/40">{t10}</p>;
      $[15] = t10;
      $[16] = t11;
    } else {
      t11 = $[16];
    }
    const t12 = <div className="py-4 text-center"><p className="text-xs text-white/40">{t("Copyright", {
          year
        })}</p>{t11}</div>;
    let t13;
    if ($[17] !== t12) {
      t13 = <div className="pb-20 lg:hidden">{t8}{t9}{t12}</div>;
      $[17] = t12;
      $[18] = t13;
    } else {
      t13 = $[18];
    }
    let t14;
    let t15;
    if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
      t14 = <div className="mb-4 flex gap-8"><div className="flex min-w-[340px] max-w-[340px] flex-col gap-12"><Link href="/"><LogoIcon className="h-[86px] w-[74px]" /></Link></div></div>;
      t15 = <div className="mb-4 h-px w-full bg-gradient-to-r from-[#0091FF] to-[#00B9FF]" />;
      $[19] = t14;
      $[20] = t15;
    } else {
      t14 = $[19];
      t15 = $[20];
    }
    let t16;
    if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
      t16 = <div className="flex min-w-[100px] items-center gap-2.5"><GlobeIcon /><LanguageSelector /></div>;
      $[21] = t16;
    } else {
      t16 = $[21];
    }
    const t17 = t("Copyright", {
      year
    });
    let t18;
    if ($[22] !== t) {
      t18 = t("AllRightsReserved");
      $[22] = t;
      $[23] = t18;
    } else {
      t18 = $[23];
    }
    let t19;
    if ($[24] !== t17 || $[25] !== t18) {
      t19 = <div className="hidden lg:block"><div className="py-8"><div className="mx-auto max-w-[1272px]">{t14}{t15}<div className="flex items-center justify-between gap-8"><div className="flex min-w-[330px] max-w-[480px] flex-1 items-center gap-8">{t16}<div className="flex-1 text-xs text-white/40">{t17} {t18}</div></div></div></div></div></div>;
      $[24] = t17;
      $[25] = t18;
      $[26] = t19;
    } else {
      t19 = $[26];
    }
    if ($[27] !== t13 || $[28] !== t19) {
      t7 = <div className="px-4 lg:px-8">{t13}{t19}</div>;
      $[27] = t13;
      $[28] = t19;
      $[29] = t7;
    } else {
      t7 = $[29];
    }
    t4 = "fixed bottom-0 left-0 right-0 z-50 bg-[#000000] lg:hidden";
    if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = <div className="mx-1 -mb-px h-px w-full bg-gradient-to-r from-[#FFFFFF00] via-[#FFFFFF] to-[#FFFFFF00] opacity-40" />;
      $[30] = t5;
    } else {
      t5 = $[30];
    }
    t2 = "flex items-center justify-around px-2";
    t3 = mobileNavItems.map((item, index) => {
      const isActive = pathname.includes(item.href);
      return <FastNavLink href={`/${locale}/${item.href}`} key={index ?? index} className={`flex min-w-0 flex-1 flex-col items-center gap-0.5 p-2 ${isActive ? "!text-[#3D63E8]" : ""}`}>{isActive ? item.activeIcon : item.icon}<span className="truncate text-center text-[10px] leading-3 text-white">{item.label}</span></FastNavLink>;
    });
    $[0] = className;
    $[1] = locale;
    $[2] = pathname;
    $[3] = t;
    $[4] = user?.id;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
    $[9] = t6;
    $[10] = t7;
  } else {
    t2 = $[5];
    t3 = $[6];
    t4 = $[7];
    t5 = $[8];
    t6 = $[9];
    t7 = $[10];
  }
  let t8;
  if ($[31] !== t2 || $[32] !== t3) {
    t8 = <div className={t2}>{t3}</div>;
    $[31] = t2;
    $[32] = t3;
    $[33] = t8;
  } else {
    t8 = $[33];
  }
  let t9;
  if ($[34] !== t4 || $[35] !== t5 || $[36] !== t8) {
    t9 = <div className={t4}>{t5}{t8}</div>;
    $[34] = t4;
    $[35] = t5;
    $[36] = t8;
    $[37] = t9;
  } else {
    t9 = $[37];
  }
  let t10;
  if ($[38] !== t6 || $[39] !== t7 || $[40] !== t9) {
    t10 = <footer className={t6}>{t7}{t9}</footer>;
    $[38] = t6;
    $[39] = t7;
    $[40] = t9;
    $[41] = t10;
  } else {
    t10 = $[41];
  }
  return t10;
};
export type { FooterV2Props };
function _temp(store) {
  return store.user;
}